import { FC, CSSProperties, ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

interface IProps {
  title: string;
  titleAlign?: "left" | "right";
  children: ReactNode;
  learnMoreLink?: string;
  style?: CSSProperties;
}

const BookmarkCard: FC<IProps> = ({ title, titleAlign = "left", children, learnMoreLink, style }) => {
  return (
    <div className={styles.card} style={style}>
      <div className={`${styles.tab} ${styles[titleAlign]}`}>{title}</div>
      {children}
      {learnMoreLink !== undefined && (
        <Link to={learnMoreLink} className={styles.learnMore}>
          <span>Learn More</span>
          <img src="/images/right-arrow.svg" alt="Learn More" />
        </Link>
      )}
    </div>
  );
};

export default BookmarkCard;
